/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// apis
import { getCardSalesListDetail } from "../../../../apis/finances/cards";
// components
import Modal, { ModalHeader } from "../../../../components/Modal";
import { ControlTable } from "../../../../components/Table";
// utils
import { isEmpty, isNull } from "lodash";
import { viewLoading } from "../../../../utils/loading";
import Button from "../../../../components/Button";
import Comment from "../../../../components/Comment";
import { transformComNum } from "../../../../utils/validator/comNum"
import { dateToViewFormat } from "../../../../utils/date";
import SalesDetail from "./SalesDetail";

const Sales = ({ open, setOpen, data, setData, permission, submit }) => {
  const [fields] = useState([
    { title: "거래일자", key: "trDate", type: "date" },
    { title: "결제금액", key: "buyAmt", type: "comma" },
    { title: "지급금액", key: "payAmt", type: "comma" },
  ]);
  const [list, setList] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false)
  const [detailData, setDetailData] = useState({})
  const [resultRow, setResultRow] = useState({});
  // 연관 은행 입출금 내역 필드
  const [bankTransFields] = useState([
    { title: "거래일자", key: "tradeTime", type: "date" },
    { title: "계좌정보", key: "bankName" },
    { title: "입금액", key: "inAmt", type: 'comma' },
    { title: "출금액", key: "outAmt", type: 'comma' },
    { title: "적요", key: "traderName" },
    { title: "거래처", key: "clients[0].name" },
  ]);
  const [bankTransList, setBankTransList] = useState([]);
  // 연관 거래명세서 내역 필드
  const [invoiceFields] = useState([
    { title: "일자", key: "writeDate", type: 'date' },
    { title: "상호", key: "byrCorpName" },
    { title: "대표자명", key: "byrRepName" },
    {
      title: "사업자번호",
      key: "byrBizNo",
      onValue: (value) => {
        return transformComNum(value)
      }
    },
    {
      title: "공급가액",
      key: "supplyAmt",
      type: 'comma'
    },
    {
      title: "세액",
      key: "taxAmt",
      type: 'comma'
    },
    {
      title: "합계금액",
      key: "totalAmt",
      type: 'comma'
    },
    {
      title: "발행여부",
      key: "taxInvoiceIdx",
      onValue: (value, field, form) => {
        let issue = "";
        if (isNull(value)) {
          issue = "부";
        } else {
          // TODO 나중에 현금영수증 발급 추가 될 경우... 변경해야함
          issue = "세금계산서"
        }

        return issue;
      },
    },
  ]);
  const [invoiceList, setInvoiceList] = useState([])

  const cancel = () => {
    setOpen(false);
    setData({});
  };

  useEffect(() => {
    if (!isEmpty(data)) {
      _submit();
    }
  }, [data]);

  const _submit = () => {
    if (!isEmpty(data)) {
      const { payDate, cardCompany } = data;
      const body = {
        payDate,
        cardCompany,
      };
      viewLoading(true);
      getCardSalesListDetail(body)
        .then((res) => {
          const {
            bankTransList,
            cardSalesList,
            cardSalesSummary,
            invoiceList,
          } = res.data;
          setList(cardSalesList);
          setBankTransList(bankTransList);
          setInvoiceList(invoiceList)
          setResultRow({
            trDate: "합계",
            buyAmt: cardSalesSummary.buyAmt,
            totalCommAmt: cardSalesSummary.commAmt,
            payAmt: cardSalesSummary.payAmt,
          });
        })
        .catch(() => { })
        .finally(() => viewLoading(false));
    }
  };

  const handleRowClick = (data, e) => {
    if (e.target.tagName !== 'TR' && e.target.tagName !== 'TD') return
    setDetailData(data)
    setDetailOpen(true)
  }

  return (
    <>
      {!detailOpen && (
        <Modal isOpen={open} close={cancel}>
          <div className="card-summaries-detail">
            <ModalHeader>{`${data.cardCompany}(${dateToViewFormat(data.payDate)})`} 매출 상세화면</ModalHeader>
            <ControlTable fields={fields} list={list} resultRow={resultRow} onSelect={handleRowClick} />
            <div className="related-bank-account-list-container">
              <div className="related-bank-account-list-header">
                <label className="related-bank-account-list-header-title">
                  연관 은행 입출금 내역
                </label>
              </div>
              <ControlTable
                fields={bankTransFields}
                list={bankTransList}
              />
              <div className="related-bank-account-list-header">
                <label className="related-bank-account-list-header-title">
                  연관 거래명세서 내역
                </label>
              </div>
              <ControlTable
                fields={invoiceFields}
                list={invoiceList}
              />
              <div className="margin-top-24">
                <Comment
                  postIdx={data.idx}
                  postType={"card_sales_summary"}
                  submit={submit}
                />
              </div>
              <div className="margin-top-20">
                <Button className="close-button" label="닫기" onClick={cancel} />
              </div>
            </div>
          </div>
        </Modal>
      )}
      {detailOpen && (
        <SalesDetail
          open={detailOpen}
          setOpen={setDetailOpen}
          data={detailData}
          permission={permission}
        />
      )}
    </>
  );
};

export default Sales;
